import { MDS_COLORS_BACKGROUND_ACCENT_WEAK, MDS_COLORS_INK_ACCENT, MDS_COLORS_INK_WEAK, MDS_COLORS_LINE_BORDER, MDS_COLORS_SKELETON_WEAK, } from '@rappi/mustache-b2b-foundations';
import { Tooltip } from '@rappi/rests-commons-front';
import styled from 'styled-components';
export const CardContainer = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr max-content;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid ${MDS_COLORS_LINE_BORDER};
  padding: 32px 24px;
`;
export const CardHeader = styled.div `
  display: flex;
  align-items: center;
  gap: 16px;
`;
export const CardIcon = styled.div `
  width: 56px;
  height: 56px;
  min-width: 56px;
  min-height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $disabled }) => ($disabled ? MDS_COLORS_SKELETON_WEAK : MDS_COLORS_BACKGROUND_ACCENT_WEAK)};
  color: ${({ $disabled }) => ($disabled ? MDS_COLORS_INK_WEAK : MDS_COLORS_INK_ACCENT)};
  transition: all 0.2s ease-in-out;
`;
export const CardBody = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const CardFooter = styled.div `
  display: flex;
  width: 100%;
`;
export const CardTooltip = styled(Tooltip) `
  width: 100%;

  div {
    width: 100%;
  }
`;
